import React, { createContext, useState, useEffect, useContext } from 'react';
import commonApi from '../utils/api';
import { CommonContext } from './CommonContext';

export const DownloadContext = createContext();

export function DownloadContextProvider({ children }) {
    const { user } = useContext(CommonContext);

    const [addModal, setAddModal] = useState(false);
    const [allData, setAllData] = useState([]);
    const [allDownload, setAllDownload] = useState([]);
    const [viewData, setViewData] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [firstLoading, setFirstLoading] = useState(false);
    const [selected, setSelected] = useState([]);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(20);


    const handleAddModal = () => {
        setAddModal(true);
    };

    const handleCloseModal = () => {
        setAddModal(false);
    };

    const onLoadApi = () => {
        const url = user?.user_type === "Merchant" ? '/merchant/downloads' : '/admin/downloads';
        let postReq = {};
        if (user?.user_type === "Merchant") {
            postReq = { merchant_id: user?.id }
        } else {
            postReq = { admin_id: user?.id }
        }
        setAllDownload([]);
        setAllData([]);
        setFirstLoading(false);
        commonApi.post(`${url}?page=${page + 1}&per_page=${rowsPerPage}`, postReq)
            .then((response) => {
                setFirstLoading(true);
                if (response?.data?.s === 1) {
                    setAllDownload(response?.data?.data);
                    setAllData(response?.data);
                }
            })
            .catch((error) => {
                setFirstLoading(true);
                console.error('Error fetching data:', error);
            });
    };

    useEffect(() => {
        onLoadApi();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [page, rowsPerPage]);

    // You can provide any values or functions you want to make available to consumers here
    const contextValue = {
        selected,
        setSelected,
        onLoadApi,
        page,
        setPage,
        rowsPerPage,
        setRowsPerPage,
        isLoading,
        firstLoading,
        viewData,
        allDownload,
        allData,
        handleAddModal,
        handleCloseModal,
        setAddModal,
        addModal,
        setAllData,
        setAllDownload,
        setViewData,
        setFirstLoading,
        setIsLoading,
    };

    // Render the provider with children
    return <DownloadContext.Provider value={contextValue}>{children}</DownloadContext.Provider>;
}
